import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Nunca pensé que un ritual pudiera ayudarme tanto. Después de hacer el ritual de cierre de ciclos sentí una paz que no había podido lograr con terapia o journaling.',
    author: 'Laura M.',
    photo: 'https://cdn.magicpatterns.com/uploads/55PN6Na41Ya3ziqRsMu29j/testimonial_woman_4_1.webp'
  }, {
    quote: 'Este libro se convirtió en mi guía. Lo que más me impactó fue que no son rituales superficiales. Te lleva a la raíz de lo que estás viviendo.',
    author: 'Carolina P.',
    photo: 'https://cdn.magicpatterns.com/uploads/s6XBQTPaSMVKJHkr7qDUq7/WhatsApp_Image_2026-03-12_at_22.09.25_1.webp'
  }, {
    quote: 'Es como tener una maestra espiritual en casa. Lo uso cada vez que atravieso un cambio importante en mi vida.',
    author: 'Andrea G.',
    photo: 'https://cdn.magicpatterns.com/uploads/pEUsmUXocobTz6WcbXaNHV/WhatsApp_Image_2026-03-12_at_22.09.25_(1)_1.webp'
  }, {
    quote: 'Me encanta, siempre soñé con poder dirigir este tipo de ceremonias y gracias a este eBook arranqué apenas con mis primeras dos clientas.',
    author: 'Valentina R.',
    photo: 'https://cdn.magicpatterns.com/uploads/6iqa4BM68S9nN4iASLhLnn/WhatsApp_Image_2026-03-12_at_21.57.22_1.webp'
  }];
  const [current, setCurrent] = useState(0);
  const goNext = () => setCurrent(prev => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrent(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="bg-cream-dark py-14 md:py-20 relative" data-id="element-286">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[1px] bg-gold-main/50" data-id="element-287"></div>

      <div className="max-w-4xl mx-auto px-6" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mb-6 rounded-sm overflow-hidden shadow-lg" data-id="element-289">
          <img src="https://cdn.magicpatterns.com/uploads/huNTj86NKw3pPn52bVS9ux/IMG_9090_ajustada_1.webp" alt="Ceremonia de boda al aire libre" className="w-full h-auto object-cover" loading="lazy" data-id="element-290" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-291">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-292">
            Testimonios de quienes ya compraron su eBook
          </h2>
        </motion.div>

        <div className="relative" data-id="element-293">
          <div className="flex items-center gap-4" data-id="element-294">
            <button onClick={goPrev} className="flex-shrink-0 w-12 h-12 rounded-full border border-gold-main/30 bg-cream-light flex items-center justify-center text-gold-main hover:bg-gold-main hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-gold-main/50" aria-label="Testimonio anterior" data-id="element-295">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-296" />
            </button>

            <div className="flex-1 overflow-hidden" data-id="element-297">
              <AnimatePresence mode="wait" data-id="element-298">
                <motion.div key={current} initial={{
                opacity: 0,
                x: 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -40
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="bg-cream-light p-7 md:p-9 rounded-sm border border-gold-main/10 shadow-sm relative" data-id="element-299">
                  <div className="text-gold-main/30 text-5xl font-playfair absolute top-3 left-5 leading-none" data-id="element-300">
                    &ldquo;
                  </div>
                  <div className="relative z-10 space-y-5" data-id="element-301">
                    <p className="font-lora text-brown-dark text-lg italic leading-relaxed pt-3" data-id="element-302">
                      {testimonials[current].quote}
                    </p>
                    <div className="flex items-center gap-4 pt-3 border-t border-gold-main/20" data-id="element-303">
                      <img src={testimonials[current].photo} alt={testimonials[current].author} className="w-12 h-12 rounded-full object-cover border-2 border-gold-main/30 flex-shrink-0" loading="lazy" data-id="element-304" />
                      <p className="font-lora font-semibold text-brown-dark" data-id="element-305">
                        — {testimonials[current].author}
                      </p>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            <button onClick={goNext} className="flex-shrink-0 w-12 h-12 rounded-full border border-gold-main/30 bg-cream-light flex items-center justify-center text-gold-main hover:bg-gold-main hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-gold-main/50" aria-label="Siguiente testimonio" data-id="element-306">
              <ChevronRightIcon className="w-5 h-5" data-id="element-307" />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-5" data-id="element-308">
            {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrent(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors focus:outline-none ${idx === current ? 'bg-gold-main' : 'bg-gold-main/25'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-309" />)}
          </div>
        </div>
      </div>
    </section>;
}